<template>
  <v-container class="not-found-container">
    <div class="not-found-content">
      <img
        src="@/assets/img/eKitabu-bug.png"
        alt="eKitabu"
        class="not-found-logo mb-6"
      >
      <h1 class="not-found-code">
        404
      </h1>
      <h2 class="not-found-title mb-2">
        {{ $t('notFound.title') }}
      </h2>
      <p class="not-found-description mb-8">
        {{ $t('notFound.description') }}
      </p>
      <div class="not-found-actions">
        <ekitabu-button
          color="primary"
          :to="{ name: 'home' }"
          rounded
          large
          class="mr-3"
        >
          {{ $t('notFound.browseBooks') }}
        </ekitabu-button>
        <ekitabu-button
          outlined
          color="primary"
          :to="{ name: 'contact' }"
          rounded
          large
        >
          {{ $t('notFound.contactUs') }}
        </ekitabu-button>
      </div>
    </div>
    <div class="not-found-pattern" />
  </v-container>
</template>

<script>
export default {
  name: "NotFound",
  metaInfo() {
    return {
      title: this.$t('routes.notFound'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('seo.notFoundDescription'),
        },
      ],
    }
  },
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  position: relative;
  overflow: hidden;
}

.not-found-content {
  text-align: center;
  position: relative;
  z-index: 1;
}

.not-found-logo {
  max-width: 80px;
  height: auto;
  opacity: 0.8;
}

.not-found-code {
  font-size: 120px;
  font-weight: 700;
  line-height: 1;
  color: var(--v-primary-base);
  opacity: 0.15;
  margin-bottom: -20px;
}

.not-found-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--v-primaryText-base);
}

.not-found-description {
  font-size: 1.1rem;
  color: var(--v-secondaryText-base);
  max-width: 400px;
  margin: 0 auto;
}

.not-found-pattern {
  position: absolute;
  bottom: -40px;
  right: -40px;
  width: 250px;
  height: 250px;
  background-image: url('~@/assets/img/logo_pattern_corner.png');
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0.06;
}

@media (max-width: 599px) {
  .not-found-code {
    font-size: 80px;
    margin-bottom: -12px;
  }

  .not-found-title {
    font-size: 1.375rem;
  }

  .not-found-description {
    font-size: 1rem;
  }

  .not-found-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .not-found-actions .mr-3 {
    margin-right: 0 !important;
  }
}
</style>
